import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/bestdentistsurat.com/src/components/pages/all-treatments/index.jsx");
